import styled from "styled-components/macro";

export default styled.div`
 .paper-div{
    margin:0;
 }
  
`;
